export default __webpack_public_path__ + "static/media/MontserratBold.50f0257a.ttf";